// extracted by mini-css-extract-plugin
export var centerText = "_bw-8";
export var container = "_bw-0";
export var doughnutContainer = "_bw-7";
export var legend = "_bw-a";
export var legendItemColorDisplay = "_bw-b";
export var legendItemLabel = "_bw-d";
export var legendItemValue = "_bw-c";
export var lg = "_bw-5";
export var maxWidth = "_bw-9";
export var md = "_bw-4";
export var responsive = "_bw-6";
export var sm = "_bw-3";
export var xs = "_bw-2";
export var xxs = "_bw-1";